/*
 * HomePage
 */

import React from 'react';

// Others
import { Switch, Route, useRouteMatch } from 'react-router-dom';

// Components & Others
import NotFound from '../../NotFoundPage';
import FilesSpecificList from '../../../components/Models/EmployeeFiles/FilesSpecificList';
import ProcessForm from 'src/components/Models/EmployeeFiles/Form';
import ProcessFormMultipleFiles from 'src/components/Models/EmployeeFiles/FormMultipleUpload';

function EmployeeFilesSpecificPage() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path} component={FilesSpecificList} />
      <Route path={`${path}/crear`} component={ProcessForm} />
      <Route
        path={`${path}/crearMultiple`}
        component={ProcessFormMultipleFiles}
      />
      <Route exact path={path} component={NotFound} />
    </Switch>
  );
}

EmployeeFilesSpecificPage.propTypes = {};

export default EmployeeFilesSpecificPage;
